module.exports = __webpack_public_path__ + "img/Armarria.5284deca.png";